<template>
    <eventi-list-component :utente="utente" :key="keyListaEventi" :titoloEvento="titoloEvento" :pathEventResource="pathEventResource" :linkEvent="linkEvent" tipoEvento="TERAPIE COMPLICANZE"></eventi-list-component>
</template>

<script>
import EventiListComponent from "../../../base/components/EventiListComponent.vue";
export default {
    props: {
        utente: {
            type: Object,
            default: function () {
                return null;
            },
        },
    },
    components: {
        EventiListComponent,
    },

    watch: {
        utente: function () {
            this.keyListaEventi++;
        },
    },
    mounted() {},
    data() {
        return {
            titoloEvento: "Terapie Complicanze",
            pathEventResource: "/cardioterapiecomplicanze",
            keyListaEventi: 0,
            linkEvent: "/paziente/cardiologia/terapiecomplicanze",
        };
    },
};
</script>

<style></style>
